import * as React from 'react';

import type { WosIconProps } from 'types/common_types';

function arrangementsRemove(props: WosIconProps) {
  const { className } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 721.1 722.5"
      fill="currentColor"
      className={className}
    >
      <path d="M412.86,551.64c-18.45,.83-34.21-14.93-34.31-34.31,.1-19.38,15.86-35.14,34.31-34.31h265.37c20.32-.83,36.07,14.93,34.31,34.31,1.76,19.38-13.99,35.14-34.31,34.31H412.86Z" />
      <g>
        <path d="M309.33,433.14H27.65c-14.14,0-25.61-10.74-25.61-23.96V25.76C2.04,12.53,13.51,1.8,27.65,1.8H309.33c14.14,0,25.61,10.74,25.61,23.96V409.18c0,13.23-11.47,23.96-25.61,23.96Z" />
        <path d="M309.33,720.7H27.65c-14.14,0-25.61-10.74-25.61-23.96v-191.71c0-13.23,11.47-23.96,25.61-23.96H309.33c14.14,0,25.61,10.74,25.61,23.96v191.71c0,13.23-11.47,23.96-25.61,23.96Z" />
        <path d="M693.45,241.43H411.77c-14.14,0-25.61-10.74-25.61-23.96V25.76c0-13.23,11.47-23.96,25.61-23.96h281.69c14.14,0,25.61,10.74,25.61,23.96V217.47c0,13.23-11.47,23.96-25.61,23.96Z" />
      </g>
    </svg>
  );
}

export default arrangementsRemove;
